import { Timestamp } from "firebase/firestore";
import moment from "moment";

import Document from "../general/document";

export interface SyncData {
  status: "started" | "completed" | "failed";
  startAt: Timestamp;
  endAt: Timestamp;
  operations: Record<string, number>;
  log: string[];
  error?: string;
}

class Sync extends Document<SyncData> {
  get status() {
    return this.data.status;
  }
  get startAt() {
    return this.data.startAt?.toDate();
  }
  get endAt() {
    return this.data.endAt?.toDate();
  }
  get duration() {
    const startAt = moment(this.startAt);
    const endAt = moment(this.endAt);
    if (endAt.isBefore(startAt)) {
      endAt.add(24, "hour");
    }
    return moment.duration(endAt.diff(startAt));
  }
  get operations() {
    return this.data.operations;
  }
  get log() {
    return this.data.log;
  }
  get hasError() {
    return !!this.data.error;
  }
  get error() {
    return this.data.error;
  }
}

export default Sync;
